import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../../api/http";
import "../../styles/login/Login.css";
import { decodeJwt } from "../../api/auth";

function Login() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({ identifier: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const toggleShowPassword = () => setShowPassword((v) => !v);

  const alertError = (message) => {
    const alertDiv = document.createElement("div");
    alertDiv.className = "sr-login__toast sr-login__toast--error";
    alertDiv.textContent = message;
    document.body.appendChild(alertDiv);
    setTimeout(() => alertDiv.remove(), 3000);
  };

  const parseError = (err) => {
    const data = err?.response?.data;

    if (!data) return "Numele de utilizator/email sau parola sunt incorecte.";
    if (typeof data === "string") return data;
    if (typeof data.detail === "string") return data.detail;

    if (Array.isArray(data.non_field_errors) && data.non_field_errors.length) {
      return data.non_field_errors.join(", ");
    }

    if (typeof data === "object") {
      const msg = Object.entries(data)
        .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(", ") : String(v)}`)
        .join("\n");
      return msg || "Numele de utilizator/email sau parola sunt incorecte.";
    }

    return "Numele de utilizator/email sau parola sunt incorecte.";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.identifier.trim()) {
      alertError("Introduceți numele de utilizator sau adresa de email.");
      return;
    }
    if (!formData.password) {
      alertError("Introduceți parola.");
      return;
    }

    try {
      const response = await api.post("/authen/login/", {
        identifier: formData.identifier,
        password: formData.password,
      });

      const data = response.data;

      sessionStorage.setItem("access", data.access);
      sessionStorage.setItem("refresh", data.refresh);

      const payload = decodeJwt(data.access);
      const isSuper = Boolean(payload?.is_superuser);

      navigate(isSuper ? "/admin" : "/", { replace: true });
    } catch (err) {
      alertError(parseError(err));
    }
  };

  return (
    <div className="sr-login">
      <div className="sr-login__card">
        <div className="sr-login__head">
          <h2 className="sr-login__title">Autentificare</h2>
          <p className="sr-login__subtitle">pentru a avea acces la contul tău.</p>
        </div>

        <form onSubmit={handleSubmit} className="sr-login__form">
          <div className="sr-login__field">
            <label htmlFor="identifier" className="sr-login__label">
              Nume utilizator sau Email
            </label>
            <input
              type="text"
              id="identifier"
              name="identifier"
              placeholder="Introdu numele de utilizator sau email-ul"
              value={formData.identifier}
              onChange={handleChange}
              className="sr-login__input"
              autoComplete="username"
            />
          </div>

          <div className="sr-login__field">
            <div className="sr-login__labelRow">
              <label htmlFor="password" className="sr-login__label">
                Parolă
              </label>
              <Link to="/reset-password" className="sr-login__link">
                Ai uitat parola?
              </Link>
            </div>

            <div className="sr-login__passwordWrap">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                placeholder="Introdu parola"
                value={formData.password}
                onChange={handleChange}
                className="sr-login__input"
                autoComplete="current-password"
              />

              <button
                type="button"
                className={["sr-login__eye", showPassword ? "is-active" : ""].join(" ")}
                onClick={toggleShowPassword}
                aria-label={showPassword ? "Ascunde parola" : "Afișează parola"}
              >
                👁
              </button>
            </div>
          </div>

          <button type="submit" className="sr-login__submit">
            Intră în cont
          </button>
        </form>

        <div className="sr-login__footer">
          <span className="sr-login__footerText">Nu ai un cont?</span>
          <Link to="/register" className="sr-login__link sr-login__link--strong">
            Sign Up
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Login;